export default "__VITE_ASSET__CIxkYfvo__"